import * as React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

interface RAGStatusChartProps {
  greenCount: number;
  amberCount: number;
  redCount: number;
}

export const RAGStatusChart = ({ greenCount, amberCount, redCount }: RAGStatusChartProps): React.JSX.Element => {
  const data = [
    { name: 'Green', value: greenCount, color: '#28a745' },
    { name: 'Amber', value: amberCount, color: '#ffc107' },
    { name: 'Red', value: redCount, color: '#dc3545' },
  ];

  // Filter out zero values for cleaner display
  const filteredData = data.filter((entry) => entry.value > 0);

  const COLORS = filteredData.map((entry) => entry.color);

  const renderCustomLabel = (entry: any) => {
    return `${entry.name}: ${entry.value}`;
  };

  return (
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie
          data={filteredData}
          cx="50%"
          cy="50%"
          labelLine={false}
          label={renderCustomLabel}
          outerRadius={100}
          fill="#8884d8"
          dataKey="value"
        >
          {filteredData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
};
